export default {
    install(app) {
        app.config.globalProperties.$globalPlugins = {
            slugifyDepartmentName: (department) => {
                if (department.charAt(department.length - 1) == '.') {
                    department = department.slice(0, -1)
                }
                return department.toLowerCase().replace(/\./g, '').replace(/&/g, 'and').replace(/\s+/g, '_')
            }
        }
    }
}